export default __webpack_public_path__ + "static/media/medkit.5a57764e.svg";